import CommuneForm from './CommuneForm';

export default CommuneForm;
